import React from 'react';
import { Helmet } from 'react-helmet-async';

function SmsPolicy() {
	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>SMS Terms • Appex Connect Hub</title>
				</Helmet>
				<h2>SMS Terms & Disclosures</h2>
				<ul className="helper">
					<li>By opting in, you agree to receive marketing texts from APEX SPECIALTY CONTRACTING LLC (Appex Connect Hub).</li>
					<li>Message frequency varies. Message and data rates may apply.</li>
					<li>Reply STOP to opt out at any time. Reply HELP for help.</li>
					<li>Consent is not required as a condition to receive services or obtain credit.</li>
					<li>We may send service-related notifications (e.g., request confirmations).</li>
					<li>Carriers are not liable for delayed or undelivered messages.</li>
				</ul>
				<div className="card" style={{ padding: 18, marginTop: 12 }}>
					<p className="helper" style={{ margin: 0 }}>
						By providing your phone number, you consent to receive SMS messages from APEX SPECIALTY CONTRACTING LLC related to service updates,
						scheduling, and project communication. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe. Reply HELP for help.
					</p>
				</div>
				<p className="helper" style={{ marginTop: 12 }}>Questions? Contact: 183 Highland Rd, Tarpon Springs, FL 34689</p>
			</div>
		</section>
	);
}

export default SmsPolicy;


